import type { SVGProps } from "react";

export type IconName =
  | "overview"
  | "accounts"
  | "tasks"
  | "integrations"
  | "credits"
  | "logout"
  | "arrow"
  | "refresh"
  | "pulse"
  | "user"
  | "search"
  | "eye"
  | "eye-off"
  | "key"
  | "network"
  | "clock"
  | "check"
  | "alert"
  | "copy"
  | "download"
  | "play"
  | "trash";

interface IconProps extends SVGProps<SVGSVGElement> {
  name: IconName;
  size?: number;
}

export function Icon({ name, size = 20, ...props }: IconProps) {
  const common = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
    "aria-hidden": true,
    ...props,
  };

  switch (name) {
    case "overview":
      return <svg {...common}><path d="M4 13h6V4H4v9Zm0 7h6v-4H4v4Zm10 0h6v-9h-6v9Zm0-13h6V4h-6v3Z" /></svg>;
    case "accounts":
      return <svg {...common}><path d="M4 5.5h7l2 2H20v11H4v-13Z" /><path d="M8 12h8M8 15.5h5" /></svg>;
    case "tasks":
      return <svg {...common}><path d="M8 4h8M9 3v3m6-3v3M6 6h12v14H6V6Z" /><path d="m9 12 2 2 4-4m-6 7h6" /></svg>;
    case "integrations":
      return <svg {...common}><path d="M8 7V4m8 3V4M6 8h12v3a6 6 0 0 1-12 0V8Zm6 9v3m-3 0h6" /></svg>;
    case "credits":
      return <svg {...common}><path d="M4 7.5A2.5 2.5 0 0 1 6.5 5H19v14H6.5A2.5 2.5 0 0 1 4 16.5v-9Z" /><path d="M4 8h15m-6 5h6v3h-6a1.5 1.5 0 0 1 0-3Z" /></svg>;
    case "logout":
      return <svg {...common}><path d="M10 5H5v14h5m4-4 4-3-4-3m4 3H9" /></svg>;
    case "arrow":
      return <svg {...common}><path d="m9 18 6-6-6-6" /></svg>;
    case "refresh":
      return <svg {...common}><path d="M20 7v5h-5M4 17v-5h5" /><path d="M7 7a7 7 0 0 1 11.5 2M17 17A7 7 0 0 1 5.5 15" /></svg>;
    case "pulse":
      return <svg {...common}><path d="M3 12h4l2-6 4 12 2-6h6" /></svg>;
    case "user":
      return <svg {...common}><circle cx="12" cy="8" r="3.5" /><path d="M5 20a7 7 0 0 1 14 0" /></svg>;
    case "search":
      return <svg {...common}><circle cx="11" cy="11" r="6" /><path d="m16 16 4 4" /></svg>;
    case "eye":
      return <svg {...common}><path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z" /><circle cx="12" cy="12" r="2.5" /></svg>;
    case "eye-off":
      return <svg {...common}><path d="m4 4 16 16M10.7 6.1A10.8 10.8 0 0 1 12 6c6 0 9.5 6 9.5 6a15 15 0 0 1-2.1 2.8M7.2 7.2C4.2 9 2.5 12 2.5 12s3.5 6 9.5 6a9.9 9.9 0 0 0 3.1-.5" /></svg>;
    case "key":
      return <svg {...common}><circle cx="8" cy="15" r="4" /><path d="m11 12 8-8m-3 3 2 2m-5 1 2 2" /></svg>;
    case "network":
      return <svg {...common}><circle cx="12" cy="5" r="2" /><circle cx="6" cy="18" r="2" /><circle cx="18" cy="18" r="2" /><path d="M12 7v4m0 0-6 5m6-5 6 5" /></svg>;
    case "clock":
      return <svg {...common}><circle cx="12" cy="12" r="8" /><path d="M12 8v4l3 2" /></svg>;
    case "check":
      return <svg {...common}><path d="m5 12 4 4L19 6" /></svg>;
    case "alert":
      return <svg {...common}><path d="M12 4 3.5 19h17L12 4Z" /><path d="M12 9v4m0 3h.01" /></svg>;
    case "copy":
      return <svg {...common}><rect x="8" y="8" width="11" height="12" rx="1.5" /><path d="M16 8V5.5A1.5 1.5 0 0 0 14.5 4h-9A1.5 1.5 0 0 0 4 5.5v10A1.5 1.5 0 0 0 5.5 17H8" /></svg>;
    case "download":
      return <svg {...common}><path d="M12 4v11m0 0 4-4m-4 4-4-4M5 20h14" /></svg>;
    case "play":
      return <svg {...common}><path d="m8 5 11 7-11 7V5Z" /></svg>;
    case "trash":
      return <svg {...common}><path d="M5 7h14m-9-3h4l1 3H9l1-3Zm-3 3 1 12h8l1-12M10 11v7m4-7v7" /></svg>;
  }
}
